<template>
   <div>
       <!-- Trigger Button -->
       <button
           @click="handleModal(2)"
           class="btn-rate sm:hidden md:flex justify-center bg-transparent hover:bg-orange text-orange font-bold hover:text-white py-4 px-8 border border-orange hover:border-transparent rounded"
       >
           <span class="flex items-center gap-0.5">
               <svg width="14" height="13" viewBox="0 0 14 13" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                   <path d="M6.30974 0.787778C6.49258 0.225061 7.28867 0.225063 7.47151 0.78778L8.54961 4.10583C8.63138 4.35748 8.86589 4.52786 9.13049 4.52786H12.6193C13.211 4.52786 13.457 5.28499 12.9783 5.63277L10.1558 7.68344C9.94173 7.83897 9.85216 8.11465 9.93392 8.36631L11.012 11.6844C11.1949 12.2471 10.5508 12.715 10.0721 12.3672L7.24963 10.3166C7.03556 10.161 6.74569 10.161 6.53162 10.3166L3.70912 12.3672C3.23044 12.715 2.58639 12.2471 2.76923 11.6844L3.84733 8.36631C3.92909 8.11466 3.83952 7.83897 3.62545 7.68344L0.802948 5.63277C0.324272 5.28499 0.57028 4.52786 1.16196 4.52786H4.65076C4.91536 4.52786 5.14987 4.35748 5.23164 4.10583L6.30974 0.787778Z"
                   />
               </svg>

               <span> {{label}}</span>
           </span>
       </button>
       <button
           @click="handleModal(2)"
           class="btn btn--outlined btn--full md:hidden"
       >
          <span class="flex items-center justify-center gap-0.5">
               <svg width="14" height="13" viewBox="0 0 14 13" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                   <path d="M6.30974 0.787778C6.49258 0.225061 7.28867 0.225063 7.47151 0.78778L8.54961 4.10583C8.63138 4.35748 8.86589 4.52786 9.13049 4.52786H12.6193C13.211 4.52786 13.457 5.28499 12.9783 5.63277L10.1558 7.68344C9.94173 7.83897 9.85216 8.11465 9.93392 8.36631L11.012 11.6844C11.1949 12.2471 10.5508 12.715 10.0721 12.3672L7.24963 10.3166C7.03556 10.161 6.74569 10.161 6.53162 10.3166L3.70912 12.3672C3.23044 12.715 2.58639 12.2471 2.76923 11.6844L3.84733 8.36631C3.92909 8.11466 3.83952 7.83897 3.62545 7.68344L0.802948 5.63277C0.324272 5.28499 0.57028 4.52786 1.16196 4.52786H4.65076C4.91536 4.52786 5.14987 4.35748 5.23164 4.10583L6.30974 0.787778Z"
                   />
               </svg>

               <span> {{label}}</span>
           </span>
       </button>

       <!-- Order Rating Modal -->
       <div v-if="showModal" id="order-rating-modal" class="toggle-alert--progress-modal" :class="{'toggle-alert' : showModal}">
           <div class="flex items-center justify-center h-screen m-auto max-h-[90vh] p-4">
               <div class="relative max-h-5/6 overflow-y-auto w-full max-w-lg mx-auto bg-orange-gradLight rounded-lg">
                   <!-- Close btn -->
                   <div class="flex justify-end">
                       <button class="btn-close pr-4 pt-4" @click="handleCloseModal">
                           <img :src="icClose" alt="close">
                       </button>
                   </div>

                   <!-- Container -->
                   <div class="py-6 max-w-md mx-auto">
                       <div v-if="isFormSent" >
                           <div class="flex justify-center">
                               <svg width="115" height="133" viewBox="0 0 115 133" fill="none" xmlns="http://www.w3.org/2000/svg">
                                   <ellipse opacity="0.3" cx="55.781" cy="121.665" rx="40.9744" ry="11.3333" fill="#FD8D1A"/>
                                   <ellipse cx="35.5742" cy="22.2282" rx="2.99805" ry="2.99379" fill="#FD8D1A"/>
                                   <ellipse opacity="0.3" cx="3.37281" cy="40.6219" rx="3.37281" ry="3.36801" fill="#FD8D1A"/>
                                   <path fill-rule="evenodd" clip-rule="evenodd" d="M78.1953 7.29736C78.1953 3.26714 81.4671 0 85.5031 0C89.539 0 92.8108 3.26714 92.8108 7.29736C92.8108 11.3276 89.539 14.5947 85.5031 14.5947C81.4671 14.5947 78.1953 11.3276 78.1953 7.29736ZM89.4382 7.29654C89.4382 5.12642 87.6765 3.36719 85.5033 3.36719C83.3301 3.36719 81.5684 5.12642 81.5684 7.29654C81.5684 9.46666 83.3301 11.2259 85.5033 11.2259C87.6765 11.2259 89.4382 9.46666 89.4382 7.29654Z" fill="#FD8D1A"/>
                                   <ellipse opacity="0.3" cx="96.3982" cy="47.8016" rx="3.37281" ry="3.36801" fill="#FD8D1A"/>
                                   <ellipse cx="3.75391" cy="107.767" rx="2.99805" ry="2.99379" fill="#FD8D1A"/>
                                   <path fill-rule="evenodd" clip-rule="evenodd" d="M40.4371 100.991L67.7109 110.918C69.7565 111.662 73.4507 113.562 74.4473 110.824L77.3511 103.061C78.7308 103.563 81.1119 104.231 81.777 102.404C83.266 98.3125 83.9179 96.5711 85.3972 92.5066C86.2975 92.8343 87.3686 92.096 87.6807 91.2383L90.2807 84.0949C90.5929 83.2373 90.5125 81.5852 89.5057 81.2188L92.6932 72.4613C93.6568 69.8138 89.824 67.8637 87.8903 67.1599L69.4968 60.4652C67.4778 59.7304 66.7933 57.2853 68.0467 55.5819L75.6363 43.1663C76.1809 42.2666 76.6427 39.9372 76.842 37.5664C76.9611 36.0956 77.2446 33.7917 76.3384 32.5027C75.3377 31.0586 73.5389 29.7524 71.8003 29.5238L65.4077 39.8775C65.0975 40.3981 64.6582 40.7932 64.1616 41.0468L43.7784 53.4265L33.1516 82.6232C32.1435 85.3931 31.5342 88.4593 31.947 91.4026C32.6275 96.3618 35.9776 99.3727 40.4415 100.997L40.4371 100.991Z" fill="white"/>
                                   <path d="M93.8529 68.7778L89.7156 80.1448L85.2575 92.3933L81.5071 102.697L77.4507 104.589L74.0869 113.831" stroke="#FEEBDD" stroke-width="11"/>
                                   <path fill-rule="evenodd" clip-rule="evenodd" d="M37.1287 53.1765L22.1902 47.6307C19.1582 46.497 18.7086 47.1357 17.6461 50.0548L5.29162 83.9985C4.30474 86.71 4.03805 87.741 6.9412 88.7977L22.1437 94.3309L37.1233 53.1746L37.1287 53.1765Z" fill="white"/>
                                   <rect x="32.7148" y="49.457" width="7" height="49" transform="rotate(20 32.7148 49.457)" fill="#FEEBDD"/>
                                   <path fill-rule="evenodd" clip-rule="evenodd" d="M102.967 96.819C102.967 93.6894 105.504 91.1523 108.633 91.1523C111.763 91.1523 114.3 93.6894 114.3 96.819C114.3 99.9486 111.763 102.486 108.633 102.486C105.504 102.486 102.967 99.9486 102.967 96.819ZM111.685 96.8208C111.685 95.1356 110.318 93.7695 108.633 93.7695C106.948 93.7695 105.582 95.1356 105.582 96.8208C105.582 98.506 106.948 99.8721 108.633 99.8721C110.318 99.8721 111.685 98.506 111.685 96.8208Z" fill="#FD8D1A"/>
                               </svg>
                           </div>

                           <div class="mt-10 text-center">
                               <h3 class="text-orange">Obrigado pelo teu feedback</h3>
                               <p class="mt-2 text-gray leading-6">
                                   Ficamos felizes por saber que gostaste! A tua opinião é muito importante para nós.
                               </p>

                               <div class="w-full mt-10">
                                   <button
                                       @click="handleCloseModal()"
                                       class="btn btn--full"
                                   >
                                       Percebi
                                   </button>
                               </div>
                           </div>
                       </div>

                       <div v-else>
                           <!-- Header Title -->
                           <div class="space-y-2 text-center">
                               <p class="text-gray text-sm">
                                {{ order.date }}
                               </p>
                               <h3 class="text-orange">
                                   Avalia a tua experiência
                               </h3>
                           </div>

                           <!-- Form-->
                           <div class="relative mt-6 py-10 space-y-12 ">
                               <!-- Delivery Rating ( Thumbs )-->
                               <div class="text-center">
                                   <h4>Como avalias a entrega?</h4>
                                   <div class="mt-4 flex items-center justify-center gap-x-4">
                                       <!-- Thumbs down icon -->
                                       <button
                                           @click="setDeliveryRating('down')"
                                           @mouseover="setHoverDeliveryRating('down')"
                                           @mouseleave="setHoverDeliveryRating(false)"
                                           :class="[
                                           'w-16 h-16 p-4 rounded-full flex items-center justify-center',
                                           hoverDeliveryRating === 'down' || formData.deliveryRating === 'down' ? 'bg-gray-900 bg-opacity-100' : 'bg-orange bg-opacity-20'
                                           ]"
                                       >
                                           <svg v-if="hoverDeliveryRating === 'down' || formData.deliveryRating === 'down'"
                                                width="22" height="20"
                                                viewBox="0 0 22 20"
                                                fill="none"
                                                xmlns="http://www.w3.org/2000/svg"
                                           >
                                               <path d="M21.4826 11.5938L20.3576 2.59375C20.2891 2.04989 20.0244 1.54975 19.6132 1.18724C19.202 0.824741 18.6727 0.624812 18.1245 0.625H1.99951C1.60169 0.625 1.22016 0.783035 0.938851 1.06434C0.657547 1.34564 0.499512 1.72718 0.499512 2.125V10.375C0.499512 10.7728 0.657547 11.1544 0.938851 11.4357C1.22016 11.717 1.60169 11.875 1.99951 11.875H6.03639L9.57826 18.9606C9.64061 19.0852 9.73644 19.19 9.85501 19.2632C9.97357 19.3364 10.1102 19.3751 10.2495 19.375C11.2441 19.375 12.1979 18.9799 12.9012 18.2766C13.6044 17.5734 13.9995 16.6196 13.9995 15.625V14.125H19.2495C19.5688 14.1251 19.8844 14.0573 20.1755 13.926C20.4665 13.7947 20.7263 13.603 20.9375 13.3635C21.1488 13.1241 21.3066 12.8425 21.4006 12.5373C21.4946 12.2322 21.5225 11.9105 21.4826 11.5938ZM5.74951 10.375H1.99951V2.125H5.74951V10.375Z" fill="white"/>
                                           </svg>

                                           <svg v-else
                                                width="24" height="22"
                                                viewBox="0 0 22 20"
                                                fill="none"
                                                xmlns="http://www.w3.org/2000/svg">
                                               <path
                                                   d="M21.4826 11.5938L20.3576 2.59375C20.2891 2.04989 20.0244 1.54975 19.6132 1.18724C19.202 0.824741 18.6727 0.624812 18.1245 0.625H1.99951C1.60169 0.625 1.22016 0.783035 0.938851 1.06434C0.657547 1.34564 0.499512 1.72718 0.499512 2.125V10.375C0.499512 10.7728 0.657547 11.1544 0.938851 11.4357C1.22016 11.717 1.60169 11.875 1.99951 11.875H6.03639L9.57826 18.9606C9.64061 19.0852 9.73644 19.19 9.85501 19.2632C9.97357 19.3364 10.1102 19.3751 10.2495 19.375C11.2441 19.375 12.1979 18.9799 12.9012 18.2766C13.6044 17.5734 13.9995 16.6196 13.9995 15.625V14.125H19.2495C19.5688 14.1251 19.8844 14.0573 20.1755 13.926C20.4665 13.7947 20.7263 13.603 20.9375 13.3635C21.1488 13.1241 21.3066 12.8425 21.4006 12.5373C21.4946 12.2322 21.5225 11.9105 21.4826 11.5938ZM5.74951 10.375H1.99951V2.125H5.74951V10.375ZM19.812 12.3709C19.7421 12.4513 19.6557 12.5157 19.5586 12.5595C19.4615 12.6034 19.356 12.6257 19.2495 12.625H13.2495C13.0506 12.625 12.8598 12.704 12.7192 12.8447C12.5785 12.9853 12.4995 13.1761 12.4995 13.375V15.625C12.4997 16.1452 12.3195 16.6494 11.9898 17.0517C11.6601 17.4541 11.2012 17.7298 10.6911 17.8319L7.24951 10.9478V2.125H18.1245C18.3072 2.12494 18.4837 2.19158 18.6208 2.31242C18.7578 2.43325 18.846 2.59996 18.8689 2.78125L19.9939 11.7812C20.0079 11.8868 19.999 11.9942 19.9676 12.096C19.9362 12.1978 19.8831 12.2916 19.812 12.3709Z"
                                                   fill="#FD8D1A"
                                               />
                                           </svg>
                                       </button>

                                       <!-- Thumbs up icon -->
                                       <button
                                           @click="setDeliveryRating('up')"
                                           @mouseover="setHoverDeliveryRating('up')"
                                           @mouseleave="setHoverDeliveryRating(false)"
                                           :class="[
                                           'w-16 h-16 p-4 bg-orange rounded-full flex items-center justify-center',
                                           hoverDeliveryRating === 'up' || formData.deliveryRating === 'up' ? 'bg-opacity-100' : 'bg-opacity-20'
                                           ]"
                                       >

                                           <svg v-if="hoverDeliveryRating === 'up' || formData.deliveryRating === 'up'"
                                                width="22" height="20"
                                                viewBox="0 0 22 20"
                                                fill="none"
                                                xmlns="http://www.w3.org/2000/svg"
                                           >
                                               <path d="M20.937 6.63625C20.7258 6.39693 20.4661 6.20528 20.1752 6.07403C19.8842 5.94278 19.5687 5.87494 19.2495 5.875H13.9995V4.375C13.9995 3.38044 13.6044 2.42661 12.9012 1.72335C12.1979 1.02009 11.2441 0.625 10.2495 0.625C10.1102 0.6249 9.97357 0.663617 9.85501 0.736808C9.73645 0.809999 9.64061 0.914771 9.57826 1.03938L6.03639 8.125H1.99951C1.60169 8.125 1.22016 8.28304 0.938852 8.56434C0.657547 8.84564 0.499512 9.22717 0.499512 9.625V17.875C0.499512 18.2728 0.657547 18.6544 0.938852 18.9357C1.22016 19.217 1.60169 19.375 1.99951 19.375H18.1245C18.6727 19.3752 19.202 19.1753 19.6132 18.8128C20.0244 18.4503 20.2891 17.9501 20.3576 17.4062L21.4826 8.40625C21.5225 8.0894 21.4945 7.76768 21.4004 7.4625C21.3063 7.15732 21.1484 6.87566 20.937 6.63625ZM1.99951 9.625H5.74951V17.875H1.99951V9.625Z" fill="white"/>
                                           </svg>

                                           <svg v-else
                                                width="22" height="20"
                                                viewBox="0 0 22 20"
                                                fill="none"
                                                xmlns="http://www.w3.org/2000/svg"
                                           >
                                               <path
                                                   d="M20.937 6.63625C20.7258 6.39693 20.4661 6.20528 20.1752 6.07403C19.8842 5.94278 19.5687 5.87494 19.2495 5.875H13.9995V4.375C13.9995 3.38044 13.6044 2.42661 12.9012 1.72335C12.1979 1.02009 11.2441 0.625 10.2495 0.625C10.1102 0.6249 9.97357 0.663617 9.85501 0.736808C9.73644 0.809999 9.64061 0.914771 9.57826 1.03938L6.03639 8.125H1.99951C1.60169 8.125 1.22016 8.28304 0.938851 8.56434C0.657547 8.84564 0.499512 9.22718 0.499512 9.625V17.875C0.499512 18.2728 0.657547 18.6544 0.938851 18.9357C1.22016 19.217 1.60169 19.375 1.99951 19.375H18.1245C18.6727 19.3752 19.202 19.1753 19.6132 18.8128C20.0244 18.4503 20.2891 17.9501 20.3576 17.4062L21.4826 8.40625C21.5225 8.0894 21.4945 7.76768 21.4004 7.4625C21.3063 7.15732 21.1484 6.87566 20.937 6.63625ZM1.99951 9.625H5.74951V17.875H1.99951V9.625ZM19.9939 8.21875L18.8689 17.2188C18.846 17.4 18.7578 17.5668 18.6208 17.6876C18.4837 17.8084 18.3072 17.8751 18.1245 17.875H7.24951V9.05219L10.6911 2.16813C11.2012 2.27021 11.6601 2.5459 11.9898 2.94826C12.3195 3.35062 12.4997 3.8548 12.4995 4.375V6.625C12.4995 6.82391 12.5785 7.01468 12.7192 7.15533C12.8598 7.29598 13.0506 7.375 13.2495 7.375H19.2495C19.3559 7.37496 19.4612 7.39758 19.5582 7.44134C19.6552 7.48511 19.7418 7.54902 19.8122 7.62883C19.8826 7.70863 19.9352 7.80252 19.9665 7.90423C19.9979 8.00594 20.0072 8.11316 19.9939 8.21875Z"
                                                   fill="#FD8D1A"
                                               />
                                           </svg>



                                       </button>
                                   </div>
                               </div>
                               <!-- Products Rating ( Stars )-->
                               <div class="text-center">
                                   <h4>Como avalias os produtos?</h4>
                                   <div class="mt-4 flex items-center justify-center gap-x-2">
                                       <template v-for="star in 5" >
                                           <svg
                                               :class="[
                                                'w-16 h-16 cursor-pointer',
                                                (hoverProductsRating || formData.productsRating) >= star ? 'text-orange' : 'text-orange-gradLight'
                                              ]"
                                               @click="setProductsRating(star)"
                                               @mouseover="setProductsHoverRating(star)"
                                               @mouseleave="setProductsHoverRating(0)"
                                               xmlns="http://www.w3.org/2000/svg"
                                               :fill="(hoverProductsRating || formData.productsRating) >= star ? '#FD8D1A' : '#FAD0A4'"
                                               viewBox="0 0 24 24"
                                               stroke-width="1.5"
                                               stroke="none" >
                                               <path stroke-linecap="round" stroke-linejoin="round" d="M11.48 3.499a.562.562 0 0 1 1.04 0l2.125 5.111a.563.563 0 0 0 .475.345l5.518.442c.499.04.701.663.321.988l-4.204 3.602a.563.563 0 0 0-.182.557l1.285 5.385a.562.562 0 0 1-.84.61l-4.725-2.885a.562.562 0 0 0-.586 0L6.982 20.54a.562.562 0 0 1-.84-.61l1.285-5.386a.562.562 0 0 0-.182-.557l-4.204-3.602a.562.562 0 0 1 .321-.988l5.518-.442a.563.563 0 0 0 .475-.345L11.48 3.5Z" />
                                           </svg>
                                       </template>

                                   </div>
                               </div>

                               <!-- Show only if both ratings are selected -->
                               <div
                                   v-if="formData.productsRating && formData.deliveryRating"
                                   class="mt-6 px-4">

                                   <!--Order Description-->
                                   <textarea
                                       v-model="formData.description"
                                       class="w-full h-32 p-4 border border-gray-100 shadow-sm rounded-lg resize-none"
                                       placeholder="Escreve algo sobre o teu pedido..."
                                   ></textarea>

                                   <!-- Items -->
                                   <div
                                       v-if="formData.products.length > 0"
                                       v-for="(product, index) in formData.products"
                                       :key="product.id"
                                   >
                                       <div class="mt-8 flex items-center justify-between gap-x-2">
                                           <div class="flex items-center gap-x-2">
                                              <div>
                                                   <img
                                                       :src="product.image"
                                                       class="object-contain w-16"
                                                   />
                                               </div>
                                               <div>
                                                   <h5>{{ product.name }}</h5>
                                               </div>
                                           </div>
                                           <div class="flex items-center gap-x-2">
                                               <!-- Thumbs down icon -->
                                               <button
                                                   @click="setProductItemRate(product,'down')"
                                                   :class="[
                                               'w-10 h-10 p-3 rounded-full flex items-center justify-center',
                                               product.rating === 'down' ? 'bg-gray-900 bg-opacity-100' : ' bg-orange bg-opacity-20'
                                               ]"
                                               >
                                                   <svg v-if="product.rating === 'down'"
                                                        width="22" height="20"
                                                        viewBox="0 0 22 20"
                                                        fill="none"
                                                        xmlns="http://www.w3.org/2000/svg"
                                                   >
                                                       <path d="M21.4826 11.5938L20.3576 2.59375C20.2891 2.04989 20.0244 1.54975 19.6132 1.18724C19.202 0.824741 18.6727 0.624812 18.1245 0.625H1.99951C1.60169 0.625 1.22016 0.783035 0.938851 1.06434C0.657547 1.34564 0.499512 1.72718 0.499512 2.125V10.375C0.499512 10.7728 0.657547 11.1544 0.938851 11.4357C1.22016 11.717 1.60169 11.875 1.99951 11.875H6.03639L9.57826 18.9606C9.64061 19.0852 9.73644 19.19 9.85501 19.2632C9.97357 19.3364 10.1102 19.3751 10.2495 19.375C11.2441 19.375 12.1979 18.9799 12.9012 18.2766C13.6044 17.5734 13.9995 16.6196 13.9995 15.625V14.125H19.2495C19.5688 14.1251 19.8844 14.0573 20.1755 13.926C20.4665 13.7947 20.7263 13.603 20.9375 13.3635C21.1488 13.1241 21.3066 12.8425 21.4006 12.5373C21.4946 12.2322 21.5225 11.9105 21.4826 11.5938ZM5.74951 10.375H1.99951V2.125H5.74951V10.375Z" fill="white"/>
                                                   </svg>

                                                   <svg v-else
                                                        width="24" height="22"
                                                        viewBox="0 0 22 20"
                                                        fill="none"
                                                        xmlns="http://www.w3.org/2000/svg">
                                                       <path
                                                           d="M21.4826 11.5938L20.3576 2.59375C20.2891 2.04989 20.0244 1.54975 19.6132 1.18724C19.202 0.824741 18.6727 0.624812 18.1245 0.625H1.99951C1.60169 0.625 1.22016 0.783035 0.938851 1.06434C0.657547 1.34564 0.499512 1.72718 0.499512 2.125V10.375C0.499512 10.7728 0.657547 11.1544 0.938851 11.4357C1.22016 11.717 1.60169 11.875 1.99951 11.875H6.03639L9.57826 18.9606C9.64061 19.0852 9.73644 19.19 9.85501 19.2632C9.97357 19.3364 10.1102 19.3751 10.2495 19.375C11.2441 19.375 12.1979 18.9799 12.9012 18.2766C13.6044 17.5734 13.9995 16.6196 13.9995 15.625V14.125H19.2495C19.5688 14.1251 19.8844 14.0573 20.1755 13.926C20.4665 13.7947 20.7263 13.603 20.9375 13.3635C21.1488 13.1241 21.3066 12.8425 21.4006 12.5373C21.4946 12.2322 21.5225 11.9105 21.4826 11.5938ZM5.74951 10.375H1.99951V2.125H5.74951V10.375ZM19.812 12.3709C19.7421 12.4513 19.6557 12.5157 19.5586 12.5595C19.4615 12.6034 19.356 12.6257 19.2495 12.625H13.2495C13.0506 12.625 12.8598 12.704 12.7192 12.8447C12.5785 12.9853 12.4995 13.1761 12.4995 13.375V15.625C12.4997 16.1452 12.3195 16.6494 11.9898 17.0517C11.6601 17.4541 11.2012 17.7298 10.6911 17.8319L7.24951 10.9478V2.125H18.1245C18.3072 2.12494 18.4837 2.19158 18.6208 2.31242C18.7578 2.43325 18.846 2.59996 18.8689 2.78125L19.9939 11.7812C20.0079 11.8868 19.999 11.9942 19.9676 12.096C19.9362 12.1978 19.8831 12.2916 19.812 12.3709Z"
                                                           fill="#FD8D1A"
                                                       />
                                                   </svg>
                                               </button>

                                               <!-- Thumbs up icon -->
                                               <button
                                                   @click="setProductItemRate(product,'up')"
                                                   :class="[
                                               'w-10 h-10 p-3 bg-orange rounded-full flex items-center justify-center',
                                                product.rating === 'up' ? 'bg-opacity-100' : 'bg-opacity-20'
                                                ]"
                                               >
                                                   <svg v-if="product.rating === 'up'"
                                                        width="22" height="20"
                                                        viewBox="0 0 22 20"
                                                        fill="none"
                                                        xmlns="http://www.w3.org/2000/svg"
                                                   >
                                                       <path d="M20.937 6.63625C20.7258 6.39693 20.4661 6.20528 20.1752 6.07403C19.8842 5.94278 19.5687 5.87494 19.2495 5.875H13.9995V4.375C13.9995 3.38044 13.6044 2.42661 12.9012 1.72335C12.1979 1.02009 11.2441 0.625 10.2495 0.625C10.1102 0.6249 9.97357 0.663617 9.85501 0.736808C9.73645 0.809999 9.64061 0.914771 9.57826 1.03938L6.03639 8.125H1.99951C1.60169 8.125 1.22016 8.28304 0.938852 8.56434C0.657547 8.84564 0.499512 9.22717 0.499512 9.625V17.875C0.499512 18.2728 0.657547 18.6544 0.938852 18.9357C1.22016 19.217 1.60169 19.375 1.99951 19.375H18.1245C18.6727 19.3752 19.202 19.1753 19.6132 18.8128C20.0244 18.4503 20.2891 17.9501 20.3576 17.4062L21.4826 8.40625C21.5225 8.0894 21.4945 7.76768 21.4004 7.4625C21.3063 7.15732 21.1484 6.87566 20.937 6.63625ZM1.99951 9.625H5.74951V17.875H1.99951V9.625Z" fill="white"/>
                                                   </svg>

                                                   <svg v-else
                                                        width="22" height="20"
                                                        viewBox="0 0 22 20"
                                                        fill="none"
                                                        xmlns="http://www.w3.org/2000/svg"
                                                   >
                                                       <path
                                                           d="M20.937 6.63625C20.7258 6.39693 20.4661 6.20528 20.1752 6.07403C19.8842 5.94278 19.5687 5.87494 19.2495 5.875H13.9995V4.375C13.9995 3.38044 13.6044 2.42661 12.9012 1.72335C12.1979 1.02009 11.2441 0.625 10.2495 0.625C10.1102 0.6249 9.97357 0.663617 9.85501 0.736808C9.73644 0.809999 9.64061 0.914771 9.57826 1.03938L6.03639 8.125H1.99951C1.60169 8.125 1.22016 8.28304 0.938851 8.56434C0.657547 8.84564 0.499512 9.22718 0.499512 9.625V17.875C0.499512 18.2728 0.657547 18.6544 0.938851 18.9357C1.22016 19.217 1.60169 19.375 1.99951 19.375H18.1245C18.6727 19.3752 19.202 19.1753 19.6132 18.8128C20.0244 18.4503 20.2891 17.9501 20.3576 17.4062L21.4826 8.40625C21.5225 8.0894 21.4945 7.76768 21.4004 7.4625C21.3063 7.15732 21.1484 6.87566 20.937 6.63625ZM1.99951 9.625H5.74951V17.875H1.99951V9.625ZM19.9939 8.21875L18.8689 17.2188C18.846 17.4 18.7578 17.5668 18.6208 17.6876C18.4837 17.8084 18.3072 17.8751 18.1245 17.875H7.24951V9.05219L10.6911 2.16813C11.2012 2.27021 11.6601 2.5459 11.9898 2.94826C12.3195 3.35062 12.4997 3.8548 12.4995 4.375V6.625C12.4995 6.82391 12.5785 7.01468 12.7192 7.15533C12.8598 7.29598 13.0506 7.375 13.2495 7.375H19.2495C19.3559 7.37496 19.4612 7.39758 19.5582 7.44134C19.6552 7.48511 19.7418 7.54902 19.8122 7.62883C19.8826 7.70863 19.9352 7.80252 19.9665 7.90423C19.9979 8.00594 20.0072 8.11316 19.9939 8.21875Z"
                                                           fill="#FD8D1A"
                                                       />
                                                   </svg>
                                               </button>
                                           </div>
                                       </div>

                                   </div>

                                   <!-- Photos -->
                                   <div class="mt-10">
                                       <div>
                                           <h5>Inclui fotos do teu pedido</h5>
                                           <p>Inclui até 6 fotos</p>
                                       </div>
                                       <div class="mt-4 grid grid-cols-4 gap-4">
                                           <label
                                               class="aspect-square w-24 h-24 flex items-center justify-center border border-dashed border-orange rounded-lg cursor-pointer"
                                           >
                                               <input type="file" class="hidden" @change="onFileChange" multiple accept="image/*">
                                               <span class="text-4xl text-orange">+</span>
                                           </label>

                                           <!-- Preview Photos -->
                                           <div v-for="(photo, index) in previewPhotos" :key="index" class="relative aspect-square w-24 h-24">
                                               <img :src="photo.url" class="absolute inset-0 w-full h-full object-cover rounded-lg">
                                               <div v-if="photo.loading" class="absolute inset-0 flex items-center justify-center bg-black bg-opacity-50 rounded-lg">
                                                   <svg class="animate-spin h-10 w-10 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                                                       <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                                                       <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                                                   </svg>
                                               </div>
                                               <button
                                                   v-if="!photo.loading"
                                                   @click="removePhoto(index)"
                                                   class="absolute top-1 right-1 bg-gray-400 text-white rounded-full w-6 h-6 flex items-center justify-center"
                                               >
                                                   ×
                                               </button>
                                           </div>
                                       </div>
                                   </div>

                                   <div v-if="formErrors" class="mt-2">
                                       <p class="text-red-500">{{formErrors}}</p>
                                   </div>

                                   <div class="w-full mt-6">
                                       <button
                                           @click="(event) => submitReview(event)"
                                           class="btn btn--full"
                                       >
                                           Submeter
                                       </button>
                                   </div>
                               </div>
                           </div>

                           <!-- Maybe later -->
                           <div v-if="!formData.productsRating || !formData.deliveryRating" 
                                class="pb-6 text-center">
                                <button
                                    class="text-orange font-semibold"
                                    @click="handleCloseModal"
                                >
                                    Talvez mais tarde
                                </button>
                           </div>
                       </div>
                       
                   </div>
               </div>
           </div>
       </div>
   </div>
</template>

<script>

import icClose from '../../../svg/ic_close_orange.svg';
import {PRODUCT_BAG_CODE} from "../../constants";

import { EventBus } from '../../event-bus';

export default {
    props: {
        label: {
            default: 'Avaliar',
            //required: true
        },
        order: {
            required: true,
        }
    },
    data() {
        return{
            showModal: false,
            icClose: icClose,
            isFormSent: false,
            formErrors: null,
            hoverDeliveryRating: null,
            hoverProductsRating: null,
            products: [],
            previewPhotos: [],
            formData: {
                //orderCode: this.props.order.code,
                deliveryRating: null,
                productsRating: null,
                description: '',
                products: [],
                photos: [],
            },
        }
    },
    created(){
        const orderProducts = this.order.original_order_items;
        this.products = orderProducts
            .filter(({ product }) => product.code !== PRODUCT_BAG_CODE)
            .map(({ product }) => ({
                id: product.code,
                code: product.code,
                name: product.name,
                description: product.description,
                image: product.images.s,
                rating: null,
        }));
    },
    mounted() {
        console.log('order', this.order)
    },
    mounted() {},
    methods: {
        bodyOverflow() {
            document.querySelector('html').classList.toggle('no-scroll');
            document.querySelector('body').classList.toggle('no-scroll');
        },
        handleModal(){
            this.resetForm();
            this.showModal = true
            this.bodyOverflow();
        },
        handleCloseModal() {
            this.showModal = false;
            this.bodyOverflow();

            //Reset Form
            this.resetForm()
        },
        setDeliveryRating(value) {
            this.formData.deliveryRating = value;
        },
        setHoverDeliveryRating(value) {
            this.hoverDeliveryRating = value;
        },
        setProductsRating(value) {
            this.formData.productsRating = value;
        },
        setProductsHoverRating(value) {
            this.hoverProductsRating = value;
        },
        setProductItemRate(item, value) {
            const product = this.formData.products.find(p => p.id === item.id);
            if (product) product.rating = value;
        },
        onFileChange(e) {
            const files = e.target.files;
            for (let file of files) {
                this.addPhoto(file);
            }
        },
        addPhoto(file) {
            if(this.previewPhotos.length >= 6){
                this.formErrors = 'Atingiu o limite máximo de 6 fotos'
                return;
            }
            else{
                const reader = new FileReader();
                const photo = { loading: true, url: '' };
                this.previewPhotos.unshift(photo)
                reader.onload = (e) => {
                    photo.url = e.target.result;
                    setTimeout(() => {
                        photo.loading = false;
                        //photo.url = e.target.result;
                    }, 1000);
                };
                this.formData.photos.unshift(file);
                reader.readAsDataURL(file);
            }
        },
        removePhoto(index) {
            this.formData.photos.splice(index, 1);
            this.previewPhotos.splice(index, 1);
        },
        validateForm(){
            //reset form errors
            this.formErrors = null;

            const products = this.formData.products
            const hasNullRating = products.some(({ rating }) => rating === null);

            if(hasNullRating){
                this.formErrors = 'Por favor, avalia todos os produtos da compra'
                return false;
            }

            return true;
        },
        resetFormFields() {
            this.formErrors = null;
            this.formData = {
                deliveryRating: null,
                productsRating: null,
                description: '',
                products: this.products,
                photos: [],
            }
        },
        resetForm() {
            this.resetFormFields()
            this.isFormSent = false
        },
        submitReview(e) {
            e.preventDefault();

            if(!this.validateForm()){
                return
            }

            let formPayload = new FormData()

            formPayload.append('order_id', this.order.id?.toString() ?? '');
            formPayload.append('rate_shipping', this.formData.deliveryRating === 'up' ? '1' : '0');
            formPayload.append('rate_products', this.formData.productsRating.toString());
            formPayload.append('review_text', this.formData.description);

            this.formData.products.forEach((product, index) => {
                formPayload.append(
                    `review_products[${index}][product_id]`,
                    product.code
                );
                formPayload.append(
                    `review_products[${index}][rate]`,
                    product.rating === 'up' ? '1' : '0'
                );
            });

            this.formData.photos.forEach((photo, index) => {
                formPayload.append(`photos[${index}]`, photo);
            });

            return axios.post('/review', formPayload, {
                headers: { 'Content-Type': 'multipart/form-data' }
            }).then(response => {
                this.isFormSent = true;
                this.resetFormFields();
            }).catch(error => {
                EventBus.$emit('display-error', {
                    message: 'Erro ao submeter a avaliação',
                });
            });

        }
    },
}

</script>
